export default __webpack_public_path__ + "static/media/Vikasbandhu_Two.a38c8f2d.jpg";